import { render, staticRenderFns } from "./StepForMobile.vue?vue&type=template&id=796c8758&scoped=true&"
import script from "./StepForMobile.vue?vue&type=script&lang=js&"
export * from "./StepForMobile.vue?vue&type=script&lang=js&"
import style0 from "./StepForMobile.vue?vue&type=style&index=0&id=796c8758&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796c8758",
  null
  
)

export default component.exports